var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.2967 14.667C2.6627 14.667 1.33203 13.3135 1.33203 11.6506L1.33203 8.34323C1.33203 6.68376 2.6587 5.33366 4.29003 5.33366H11.7007C13.3354 5.33366 14.6654 6.68715 14.6654 8.35069V11.6567C14.6654 13.3169 13.3387 14.667 11.7074 14.667H11.0807H4.2967Z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63604 1.48069L5.69671 3.37788C5.49671 3.57396 5.49671 3.88951 5.69804 4.08495C5.89938 4.27973 6.22404 4.27908 6.42404 4.08365L7.48604 3.04415V4.04079V9.63433C7.48604 9.91028 7.71604 10.1343 7.99938 10.1343C8.28338 10.1343 8.51271 9.91028 8.51271 9.63433V3.04415L9.57471 4.08365C9.77471 4.27908 10.0994 4.27973 10.3007 4.08495C10.4014 3.9869 10.452 3.859 10.452 3.73044C10.452 3.60318 10.4014 3.47527 10.302 3.37788L8.36338 1.48069C8.26671 1.38654 8.13604 1.3333 7.99938 1.3333C7.86338 1.3333 7.73271 1.38654 7.63604 1.48069Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.4b378fa71b1792e4e65a3a6cacb2d3f0.svg";
export { ForwardRef as ReactComponent };